<!--

	Button that displays a scope and sequence modal window when clicked.

-->
<template>
	<div v-if="scopeAndSequenceStore?.IsSidebarButtonShown" class="mia-ScopeAndSequenceButton">
		<a
			class="btn mia-btn-primary btn-block"
			data-toggle="modal"
			data-target="#scopeAndSequence"
		>
			<span class="glyphicon glyphicon-book" />
			<span v-tr="'curriculum_action_scopeandsequencemodal'" />
		</a>
		<scope-and-sequence-modal id="scopeAndSequence" :scope-and-sequence-links="scopeAndSequenceLinks" />
	</div>
</template>
<script lang="ts">
import { Component, Prop, toNative, Vue } from "vue-facing-decorator";
import { MiaPlaza } from "@/Reinforced.Typings";
import ScopeAndSequenceModal from "./ScopeAndSequenceModal.vue";
import { useScopeAndSequenceStore, defineScopeAndSequenceStore, type ScopeAndSequenceStore } from "@/curriculum/parents/ScopeAndSequenceStore";

@Component({
	components: {
		ScopeAndSequenceModal
	}
})
export class ScopeAndSequenceButton extends Vue {
	@Prop({ type: Object, required: true }) scopeAndSequenceLinks!: Record<MiaPlaza.Model.Subject, string>;

	scopeAndSequenceStore: ScopeAndSequenceStore | null = null;

	async created() {
		defineScopeAndSequenceStore(this.scopeAndSequenceLinks);

		this.scopeAndSequenceStore = await useScopeAndSequenceStore();
	}
}

export default toNative(ScopeAndSequenceButton);
</script>
<style lang="scss">
.mia-ScopeAndSequenceButton {
	margin-top: theme.$mia-margin-size;

	@media (max-width: theme.$screen-md-max) {
		.btn {
			padding: theme.$mia-padding-panel;
		}
	}
}
</style>
